import { generateClient } from "aws-amplify/api";
import { AUTH_MODE } from "constants/config";
import { createTrafficMonitoring, deleteTrafficMonitoring, updateTrafficMonitoring } from "graphql/mutations";
import { getTrafficMonitoring, listTrafficMonitorings } from "graphql/queries";

const client = generateClient();

export const apiCreateTrafficMonitoring = async (input) => {
    try {
        await client.graphql({
            query: createTrafficMonitoring,
            variables: {input},
            authMode: AUTH_MODE
        });
        return { success: true};
    } catch (error) {
        throw error;
    }
};

export const apiUpdateTrafficMonitoring = async (routeId, input) => {
    try {
        const res = await client.graphql({
            query: updateTrafficMonitoring,
            variables: {
                input: {
                    type: 'TrafficMonitoring',
                    routeId,
                    ...input
                }
            },
            authMode: AUTH_MODE
        });
        return { success: true, data: res.data.updateTrafficMonitoring };
    } catch (error) {
        throw error;
    }
};

export const apiCheckDuplicateRouteId = async (routeId) => {
    try {
        const result = await client.graphql({
            query: getTrafficMonitoring,
            variables: {
                type: 'TrafficMonitoring',
                routeId
            },
            authMode: AUTH_MODE
        });
        return {
            isExisted: !!result.data.getTrafficMonitoring
        }
    } catch (error) {
        throw error;
    }
};

export const apiCheckDuplicateRouteName = async (routeName) => {
    try {
        const result = await client.graphql({
            query: listTrafficMonitorings,
            variables: {
                filter: { routeName: { eq: routeName } }
            },
            authMode: AUTH_MODE
        });
        return {
            isExisted: result.data.listTrafficMonitorings.items.length > 0
        }
    } catch (error) {
        throw error;
    }
};

export const apiGetListTrafficMonitoring = async (perPage = 150, nextToken = null, getAll = false, sortDirection = 'ASC') => {
    try {
        if (!getAll) {
            // Single page fetch
            const result = await client.graphql({
                query: listTrafficMonitorings,
                variables: {
                    type: 'TrafficMonitoring',
                    limit: perPage,
                    nextToken,
                    sortDirection
                },
                authMode: AUTH_MODE
            });
            if (!result?.data?.listTrafficMonitorings?.items) {
                return {items: [], nextToken: null};
            }
            return {
                items: result.data.listTrafficMonitorings.items.map(item => ({
                    routeId: item.routeId,
                    routeName: item.routeName,
                    routeDataKey: item.routeDataKey.split('/').pop(),
                    trafficDirections: JSON.parse(item.trafficDirections) || []
                })),
                nextToken: result.data.listTrafficMonitorings.nextToken
            };
        }

        // Fetch all pages
        let allItems = [];
        let currentNextToken = nextToken;

        do {
            const result = await client.graphql({
                query: listTrafficMonitorings,
                variables: {
                    type: 'TrafficMonitoring',
                    limit: perPage,
                    nextToken: currentNextToken,
                    sortDirection
                },
                authMode: AUTH_MODE
            });

            if (result?.data?.listTrafficMonitorings?.items) {
                const mappedItems = result.data.listTrafficMonitorings.items.map(item => ({
                    routeId: item.routeId,
                    routeName: item.routeName,
                    routeDataKey: item.routeDataKey.split('/').pop(),
                    trafficDirections: JSON.parse(item.trafficDirections) || []
                }));
                allItems.push(...mappedItems);
            }

            currentNextToken = result?.data?.listTrafficMonitorings?.nextToken;
        } while (currentNextToken);

        return {
            items: allItems,
            nextToken: null
        };
    } catch (error) {
        throw error;
    }
};

export const apiDeleteTrafficMonitoring = async (routeId) => {
    try {
        const result = await client.graphql({
            query: deleteTrafficMonitoring,
            variables: {
                input: {
                    type: 'TrafficMonitoring',
                    routeId
                }
            },
            authMode: AUTH_MODE
        });
        return { success: true, data: result.data.deleteTrafficMonitoring };
    } catch (error) {
        throw error;
    }
}